const Login = () => {
    return (
        <h1>hayo mau ngapain</h1>
    );
};

export default Login;